import { render, staticRenderFns } from "./CheckList.vue?vue&type=template&id=bd45a9a0&scoped=true"
import script from "./CheckList.vue?vue&type=script&lang=js"
export * from "./CheckList.vue?vue&type=script&lang=js"
import style0 from "./CheckList.vue?vue&type=style&index=0&id=bd45a9a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd45a9a0",
  null
  
)

export default component.exports